import React from 'react';
import PropTypes from 'prop-types';

const BannerCloseIcon = (props) => {
  return (
    <svg width="18px" height="19px" viewBox="0 0 18 19" version="1.1" xmlns="http://www.w3.org/2000/svg" >

      <title>Close</title>

      <g id="Arranged" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Confirmation-Dialogs" transform="translate(-639.000000, -102.000000)" fill={props.fill}>
          <g id="Alert-Notification-v3---success-Copy" transform="translate(70.000000, 89.000000)">
            <g id="Close" transform="translate(569.000000, 13.000000)">
              <path d="M13.3062201,12.5204306 L12.3050239,13.5323923 L9.07535885,10.3027273 L5.84569378,13.5323923 L4.84449761,12.5204306 L8.07416268,9.29076555 L4.84449761,6.06110048 L5.84569378,5.05990431 L9.07535885,8.28956938 L12.3050239,5.05990431 L13.3062201,6.06110048 L10.076555,9.29076555 L13.3062201,12.5204306 Z M9,0.28 C4.02954545,0.28 0,4.30954545 0,9.28 C0,14.2515311 4.02954545,18.28 9,18.28 C13.9704545,18.28 18,14.2515311 18,9.28 C18,9.27569378 18,9.27354067 18,9.26923445 C18,4.30416268 13.9758373,0.28 9.01076555,0.28 C9.00645933,0.28 9.00430622,0.28 9,0.28 L9,0.28 Z" id="Fill-1" />
            </g>
          </g>
        </g>
      </g>
    </svg>

  );
};

BannerCloseIcon.propTypes = {
  type: PropTypes.string,
};

BannerCloseIcon.defaultProps = {
  type: '',
};

export default BannerCloseIcon;
